import { tokensIn } from '../tokens.js';
export async function tokenContextFor(context, texts = []) {
    const board = await context.services.getBoard(context.boardId);
    const item = context.itemId === null ? null : await context.services.getItem(context.itemId);
    const actorId = context.event.actorId;
    const userName = actorId === null ? undefined : ((await context.services.userName(actorId)) ?? undefined);
    const columnText = {};
    if (context.itemId !== null) {
        const wanted = new Set();
        for (const text of texts) {
            for (const token of tokensIn(text)) {
                const parts = token.split('.');
                const tail = parts.length >= 3 && /^\d+$/.test(parts[0] ?? '') ? parts.slice(1) : parts;
                if (tail.length === 2 && tail[0] === 'pulse' && tail[1] !== 'name')
                    wanted.add(tail[1]);
            }
        }
        for (const columnId of wanted) {
            const text = await context.services.getCellText(context.itemId, columnId);
            if (text !== null) {
                columnText[columnId] = text;
                continue;
            }
            /*
             * Empty cell, or no column at all — the two cases `getCellText` cannot tell apart. The
             * board's own column list decides: a column that exists renders as nothing, a column that
             * does not keeps its literal so the mistake stays visible (P-293).
             */
            const column = await context.services.getColumn(context.boardId, columnId);
            if (column !== null)
                columnText[columnId] = '';
        }
    }
    const self = {
        boardId: context.boardId,
        boardName: board?.name,
        itemName: item?.name,
        userName,
        columnText,
        extra: extraTokensOf(context),
    };
    // A board-qualified token naming this board resolves through the same context (E11).
    return { ...self, boards: { [context.boardId]: self } };
}
/** Recipe-declared variables, e.g. `{update.preview}` on recipe 286 (sandbox E14). */
function extraTokensOf(context) {
    const extra = {};
    for (const outputs of Object.values(context.nodeResults)) {
        const preview = outputs.updatePreview;
        if (typeof preview === 'string')
            extra['update.preview'] = preview;
    }
    return extra;
}
//# sourceMappingURL=token-context.js.map